import { config } from "Utils/config";
import { logS } from "../Util/Utilities";

const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',
    CLEAR: 'clear',

    SET_INITIAL_DATA: 'set-data',
    TEXT_CHANGE: 'text-change',
    TEXT_SET_ERRORS: 'text-set-errors',
    TEXT_SET_SUCCESS: 'text-set-success',
    TEXT_REMOVE_ERRORS: 'text-remove-errors',
    TEXT_AREA_CHANGE: 'text-area-change',

    ADD_COMMENT: 'add-comment',
    REMOVE_COMMENT: 'remove-comment',
    UPDATE_COMMENT: 'update-comment',
    ADD_COMMENT_ERRORS: 'add-comment-errors'
};

const commentInputDataReducer = (state, action) => {
    var name = "SavedList";
    var type = action != null && action.hasOwnProperty("type") ? action.type : null;
    //console.log("Dispatch -",type,"-",name, state, action);
    config.isDebugEnabled && console.log("%cDispatch %c- %s -", logS.colors.brown, logS.bold,type, name, state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state
            };
        }
        case ACTIONS.CLEAR: {
            return {
                
            };
        }
        case ACTIONS.ADD_COMMENT: {
            var i = {
                ...action.input,
                value: (action.input.value).trim()
            }
            return {
                ...state,
                [action.item.id]:{
                    item: action.item,
                    input: i,
                    date: action.date
                }
            };
        }
        case ACTIONS.UPDATE_COMMENT: {
            var i = {
                ...action.input,
                value: (action.input.value).trim()
            }
            return {
                ...state,
                [action.item.id]:{
                    ...state[action.item.id],
                    item: action.item,
                    input: i,
                    date: action.date
                }
            };
        }
        case ACTIONS.REMOVE_COMMENT: {
            const array = Object.entries(state);
            const filtered = array.filter(([key,value]) => value.item.id !== action.id);
            const obj = Object.fromEntries(filtered);
            return obj;
        }

        case ACTIONS.TEXT_CHANGE: {
            return {
                ...state,
                value: action.value,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }

        case ACTIONS.TEXT_AREA_CHANGE: {
            var content = action.value;
            var maxLength = action.maxLength;
            var text = content.substring(0,maxLength);
            
            return {
                ...state,
                value: text,
                count: text.length,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        case ACTIONS.TEXT_SET_ERRORS: {
            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: action.errors != null && action.errors.length > 0 ? true : false,
                    errors: action.errors,
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        
    }
}



export {ACTIONS, commentInputDataReducer};